import type { ReactNode } from 'react';
import type { ButtonProps } from '@reactor/ui/button';
import { LoadingButton } from '@reactor/ui/loading-button';
import { useSplatParams } from '~/hooks/useSplatParams';
import { useReopen } from '~/hooks/useTaskMutations';
import { RotateCcw } from 'lucide-react';

export function ReopenButton(props: { variant?: ButtonProps['variant']; text?: string; content?: ReactNode }) {
	//
	const { variant, text, content } = props;
	const { taskId } = useSplatParams();
	const { reopen, isReopening } = useReopen();

	if (!taskId) throw new Error('Must be used within a task');

	const handleReopen = () => {
		//
		if (isReopening) return;
		reopen({ taskId });
	};

	return (
		<LoadingButton
			size="sm"
			variant={variant ?? 'outline'}
			onClick={handleReopen}
			loading={isReopening}
			loadingText="Reopening..."
			icon={<RotateCcw />}
			className="flex items-center"
		>
			{content ?? text ?? 'Reopen'}
		</LoadingButton>
	);
}
